import 'bootstrap';

export default class Application {
	public Initialize(): void {
		$('[data-toggle="popover"]').popover();

		$('form').submit((event) => this.onFormSubmit(event));
	}

	private onFormSubmit(event: JQuery.TriggeredEvent) {
		const errorElements = $(event.currentTarget).find('.invalid-feedback');
		const existAgreementTag = $(event.currentTarget).find('#agreementAccepted');
		this.applyBehaviorForErrors(errorElements);

		if (existAgreementTag.length == 0) {
			$('#wcgLoader').addClass('wcg-loader-show');
		}
		else if ($('#agreementAccepted').valid().valueOf() != false) {
			$('#wcgLoader').addClass('wcg-loader-show');
		}
		else {
			$('#wcgLoader').removeClass('wcg-loader-show');
		}
		if (errorElements.length > 0) {
			for (let i = 0; i < errorElements.length; i++) {
				if (errorElements[i].classList.contains('visible') && errorElements[i].textContent.length > 0) {
					if ($('#wcgLoader').hasClass('wcg-loader-show')) {
						$('#wcgLoader').removeClass('wcg-loader-show');
					}
					break;
				}
			}
		}
	}

	private applyBehaviorForErrors(errorElements: JQuery<HTMLElement>) {
		for (let i = 0; i < errorElements.length; i++) {
			errorElements[i].classList.add('visible');
		}

		if (!!errorElements && !!errorElements.length) {
			setTimeout(() => {
				for (let i = 0; i < errorElements.length; i++) {
					errorElements[i].classList.remove('visible');
				}
			}, 5000);
		}
	}
}



// WEBPACK FOOTER //
// ./Client/Scripts/application.ts